import { getAccountType } from "../../store/auth/selectors";

const PERMISSIONS_MATRIX = {
  "Super Admin": {
    "Create Event": true,
    "Delete Events": true,
    "Reschedule Events": true,
    "View Events": true,
    "Reset Filter": true,
    "View Student Details": true,
    "View Event Details": true,
    "View Invite Codes": true,
    "Create Invite Codes": true,
    "Upload Students": true,
    "Upload Response": true,
    "Reset Student Password": true,
    "Delete Student": true,
    "Export Student Data": true,
    "View Explore Student Details": true,
    "Export Explore Student Data": true,
    "View Schools": true,
  },
  "MIS Team Admin": {
    "Create Event": true,
    "Delete Events": true,
    "Reschedule Events": true,
    "View Events": true,
    "Reset Filter": true,
    "View Student Details": true,
    "View Event Details": true,
    "View Invite Codes": true,
    "Create Invite Codes": true,
    "Upload Students": true,
    "Upload Response": true,
    "Reset Student Password": true,
    "Delete Student": true,
    "Export Student Data": true,
    "View Explore Student Details": true,
    "Export Explore Student Data": true,
    "View Schools": true,
  },
  "General Manager": {
    "Create Event": false,
    "Delete Events": false,
    "Reschedule Events": false,
    "View Events": true,
    "Reset Filter": true,
    "View Student Details": true,
    "View Event Details": true,
    "View Invite Codes": true,
    "Create Invite Codes": true,
    "Upload Students": true,
    "Upload Response": false,
    "Reset Student Password": true,
    "Delete Student": false,
    "Export Student Data": true,
    "View Explore Student Details": true,
    "Export Explore Student Data": true,
    "View Schools": true,
  },
  "Senior Manager": {
    "Create Event": false,
    "Delete Events": false,
    "Reschedule Events": false,
    "View Events": true,
    "Reset Filter": true,
    "View Student Details": true,
    "View Event Details": true,
    "View Invite Codes": true,
    "Create Invite Codes": true,
    "Upload Students": true,
    "Upload Response": false,
    "Reset Student Password": true,
    "Delete Student": false,
    "Export Student Data": true,
    "View Explore Student Details": true,
    "Export Explore Student Data": true,
    "View Schools": true,
  },
  Manager: {
    "Create Event": false,
    "Delete Events": false,
    "Reschedule Events": false,
    "View Events": true,
    "Reset Filter": true,
    "View Student Details": true,
    "View Event Details": true,
    "View Invite Codes": true,
    "Create Invite Codes": true,
    "Upload Students": true,
    "Upload Response": false,
    "Reset Student Password": true,
    "Delete Student": false,
    "Export Student Data": true,
    "View Explore Student Details": true,
    "Export Explore Student Data": true,
    "View Schools": true,
  },
  "Execution Rep": {
    "Create Event": false,
    "Delete Events": false,
    "Reschedule Events": false,
    "View Events": true,
    "Reset Filter": true,
    "View Student Details": true,
    "View Event Details": true,
    "View Invite Codes": true,
    "Create Invite Codes": false,
    "Upload Students": true,
    "Upload Response": false,
    "Reset Student Password": true,
    "Delete Student": false,
    "Export Student Data": true,
    "View Explore Student Details": false,
    "Export Explore Student Data": false,
    "View Schools": true,
  },
  "School Admin": {
    "Create Event": false,
    "Delete Events": false,
    "Reschedule Events": false,
    "View Events": true,
    "Reset Filter": true,
    "View Student Details": true,
    "View Event Details": true,
    "View Invite Codes": false,
    "Create Invite Codes": false,
    "Upload Students": true,
    "Upload Response": false,
    "Reset Student Password": true,
    "Delete Student": false,
    "Export Student Data": true,
    "View Explore Student Details": false,
    "Export Explore Student Data": false,
    "View Schools": false,
  },
};

export const PERMISSION_TYPES = {
  CREATE_EVENT: "Create Event",
  DELETE_EVENTS: "Delete Events",
  RESCHEDULE_EVENTS: "Reschedule Events",
  VIEW_EVENTS: "View Events",
  RESET_FILTER: "Reset Filter",
  VIEW_STUDENT_DETAILS: "View Student Details",
  VIEW_EVENT_DETAILS: "View Event Details",
  VIEW_INVITE_CODES: "View Invite Codes",
  CREATE_INVITE_CODES: "Create Invite Codes",
  UPLOAD_STUDENTS: "Upload Students",
  UPLOAD_RESPONSE: "Upload Response",
  RESET_STUDENT_PASSWORD: "Reset Student Password",
  DELETE_STUDENT: "Delete Student",
  EXPORT_STUDENT_DATA: "Export Student Data",
  VIEW_EXPLORE_STUDENT_DETAILS: "View Explore Student Details",
  EXPORT_EXPLORE_STUDENT_DATA: "Export Explore Student Data",
  VIEW_SCHOOLS: "View Schools",
};

export const checkPermission = (accountType, permissionType) => {
  if (!accountType || !permissionType) {
    return false;
  }

  const rolePermissions = PERMISSIONS_MATRIX[accountType];

  if (!rolePermissions) {
    return false;
  }

  return rolePermissions[permissionType] || false;
};

export const createPermissionChecker = (state) => {
  const accountType = getAccountType(state);
  return (permissionType) => checkPermission(accountType, permissionType);
};
